"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _system = require("@ori-ui/mui-bundle/system");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable complexity -- there are a lot of options */

const styleOverrides = {
  root: ({
    theme,
    ownerState
  }) => ({
    fontWeight: 'bold',
    fontSize: '1.2rem',
    borderRadius: theme.shape.borderRadius,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    lineHeight: '1',
    textTransform: 'uppercase',
    height: 28,
    ...(ownerState.variant === 'tag' && {
      color: theme.palette.lightItem[ownerState.color ?? 'default'].textTag,
      background: theme.palette.lightItem[ownerState.color ?? 'default'].background,
      [`&.${_material.chipClasses.clickable}:hover`]: {
        background: (0, _system.alpha)(theme.palette[ownerState.color ?? 'default'].dark, 0.2)
      },
      [`&.${_material.chipClasses.clickable}.${_material.chipClasses.focusVisible}, &.${_material.chipClasses.deletable}.${_material.chipClasses.focusVisible}`]: {
        background: (0, _system.alpha)(theme.palette[ownerState.color ?? 'default'].dark, 0.2)
      },
      [`& .${_material.chipClasses.deleteIcon}`]: {
        color: theme.palette.lightItem[ownerState.color ?? 'default'].textTag,
        fontSize: '1.6rem'
      },
      [`& .${_material.chipClasses.deleteIcon}:hover`]: {
        color: theme.palette[ownerState.color ?? 'default'].dark
      },
      [`&.${_material.chipClasses.sizeMedium}`]: {
        height: 28,
        fontSize: '1.2rem'
      },
      [`&.${_material.chipClasses.sizeSmall}`]: {
        height: 25,
        fontSize: '1rem'
      }
    }),
    ...(ownerState.variant === 'filled' && {
      color: theme.palette[ownerState.color ?? 'default'].contrastText,
      background: theme.palette[ownerState.color ?? 'default'].main,
      [`&.${_material.chipClasses.clickable}:hover`]: {
        color: theme.palette.common.white,
        ...(ownerState.color === 'default' && {
          background: theme.palette.grey.A700
        })
      },
      [`&.${_material.chipClasses.clickable}.${_material.chipClasses.focusVisible}, &.${_material.chipClasses.deletable}.${_material.chipClasses.focusVisible}`]: {
        background: theme.palette[ownerState.color ?? 'default'].dark,
        color: theme.palette.common.white,
        ...(ownerState.color === 'default' && {
          background: theme.palette.grey.A700
        })
      },
      [`& .${_material.chipClasses.deleteIcon}`]: {
        color: theme.palette[ownerState.color ?? 'default'].contrastText
      },
      [`& .${_material.chipClasses.deleteIcon}:hover`]: {
        color: theme.palette[ownerState.color ?? 'default'].light
      }
    }),
    ...(ownerState.variant === 'rounded' && {
      fontWeight: 'normal',
      textTransform: 'none',
      borderRadius: 999,
      height: 32,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      color: theme.palette[ownerState.color ?? 'default'].contrastText,
      background: theme.palette[ownerState.color ?? 'default'].main,
      [`&.${_material.chipClasses.clickable}:hover`]: {
        color: theme.palette.common.white
      },
      [`&.${_material.chipClasses.clickable}.${_material.chipClasses.focusVisible}, &.${_material.chipClasses.deletable}.${_material.chipClasses.focusVisible}`]: {
        background: theme.palette[ownerState.color ?? 'default'].dark,
        color: theme.palette.common.white
      },
      [`& .${_material.chipClasses.deleteIcon}`]: {
        color: theme.palette[ownerState.color ?? 'default'].contrastText,
        fontSize: '2.2rem'
      },
      [`& .${_material.chipClasses.deleteIcon}:hover`]: {
        color: theme.palette[ownerState.color ?? 'default'].light
      },
      [`&.${_material.chipClasses.deletable}`]: {
        paddingRight: 0
      },
      ...(ownerState.color === 'default' && {
        color: theme.palette.lightItem.default.textTag,
        background: theme.palette.lightItem.default.background,
        [`&.${_material.chipClasses.clickable}:hover`]: {
          background: (0, _system.alpha)(theme.palette[ownerState.color ?? 'default'].dark, 0.2),
          color: theme.palette.lightItem.default.textTag
        },
        [`&.${_material.chipClasses.clickable}.${_material.chipClasses.focusVisible}, &.${_material.chipClasses.deletable}.${_material.chipClasses.focusVisible}`]: {
          background: (0, _system.alpha)(theme.palette[ownerState.color ?? 'default'].dark, 0.2),
          color: theme.palette.lightItem.default.textTag
        },
        [`& .${_material.chipClasses.deleteIcon}`]: {
          color: theme.palette.lightItem.default.textTag
        }
      })
    }),
    ...((ownerState.variant === 'filled' || ownerState.variant === 'rounded') && ownerState.color === 'success' && {
      color: theme.palette.text.primary,
      background: theme.palette.success.light,
      [`& .${_material.chipClasses.deleteIcon}`]: {
        color: theme.palette.text.primary
      },
      [`& .${_material.chipClasses.deleteIcon}:hover`]: {
        color: theme.palette.success.contrastText
      }
    }),
    ...(ownerState.variant === 'outlined' && (ownerState.color === 'success' || ownerState.color === 'primary') && {
      color: theme.palette[ownerState.color].dark,
      borderColor: theme.palette[ownerState.color].dark,
      [`& .${_material.chipClasses.deleteIcon}`]: {
        color: theme.palette[ownerState.color].dark
      },
      [`& .${_material.chipClasses.deleteIcon}:hover`]: {
        color: theme.palette[ownerState.color].main
      }
    })
  }),
  sizeMedium: ({
    theme,
    ownerState
  }) => ({
    fontSize: '1.4rem',
    height: 31,
    ...(ownerState.variant === 'rounded' && {
      height: 40,
      padding: theme.spacing(2, 4)
    })
  }),
  label: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 10,
    paddingRight: 10
  },
  labelSmall: {
    height: 18
  },
  labelMedium: {
    height: 21
  },
  outlined: {
    borderColor: 'currentColor',
    borderWidth: 1,
    backgroundColor: 'unset'
  }
};
const defaultProps = {
  size: 'small',
  deleteIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {
    fontSize: "inherit"
  })
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
